import UrlGeneration from '../urlGeneration';

export default class FilterPanel {
  constructor() {
    this.sFiledName = 'property'; // параметр в URL (?property[4]=5)
    this.sFilterType = 'data-filter-type';
    this.sPropertyIDAttribute = 'data-filter-property-id';

    this.sWrapperSelector = `data-filter-form`;
  }

  run() {
    UrlGeneration.init();
    this.prepareRequestData();
    UrlGeneration.update();
  }

  prepareRequestData() {
    const obFilterPropertyList = document.querySelectorAll(`[${this.sWrapperSelector}] [${this.sPropertyIDAttribute}]`);
    if (obFilterPropertyList.length == 0) {
      return;
    }

    const _self = this;

    obFilterPropertyList.forEach(function(obProperty) {
      //Get filter type
      let sFilterType = obProperty.getAttribute(`${_self.sFilterType}`);
      let iPropertyID = obProperty.getAttribute(`${_self.sPropertyIDAttribute}`);

      let sFieldName = `${_self.sFiledName}`;
      if (!sFilterType) {
        return;
      }

      if (iPropertyID) {
        sFieldName += `[${iPropertyID}]`;
      }

      let obInputList = null;
      let arValueList = [];

      if (sFilterType == 'between') {
        obInputList = obProperty.querySelectorAll('input');
      } else if (sFilterType == 'checkbox' || sFilterType == 'switch') {
        obInputList = obProperty.querySelectorAll('input[type="checkbox"]:checked');
      } else if (sFilterType == 'select' || sFilterType == 'select_between') {
        obInputList = obProperty.querySelectorAll('select');
      } else if (sFilterType == 'radio') {
        obInputList = obProperty.querySelectorAll('input[type="radio"]:checked');
      } else if (sFilterType == 'dropdown') {
          obInputList = obProperty.querySelectorAll('input[type="text"].select__input');
      }

      if (!obInputList || obInputList.length == 0) {
        UrlGeneration.remove(sFieldName);
        return;
      }

      obInputList.forEach(function(obInput) {
        let sValue = obInput.value.replace(/\s/g, '');

        if (sValue === undefined) {
            return;
        } else if (typeof(sValue) == 'string' && sValue.length === 0) {
            sValue = 0;
        }
        arValueList.push(sValue);
      });

      if (!arValueList || arValueList.length == 0 || arValueList.every(item => item === 0)) {
        UrlGeneration.remove(sFieldName);
      } else {
        UrlGeneration.set(sFieldName, arValueList);
      }
    }, _self);
  }

  /**
   * Redeclare default selector of filter input
   * Default value is "_shopaholic-filter-wrapper"
   *
   * @param {string} sWrapperSelector
   * @returns {ShopaholicFilterPanel}
   */
  setWrapperSelector(sWrapperSelector) {
    this.sWrapperSelector = sWrapperSelector;

    return this;
  }

  /**
   * Redeclare default URL filed name
   * Default value is "property"
   *
   * @param {string} sFieldName
   * @returns {ShopaholicFilterPanel}
   */
  setFieldName(sFieldName) {
    this.sFiledName = sFieldName;

    return this;
  }
}
